import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { lazy, Suspense, useEffect } from 'react';
import ReactGA from 'react-ga4';
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';
import RouterAnalytics from './components/utilComponents/RouterAnalytics';
import RouteLoadingFallback from './components/utilComponents/RouteLoadingFallback';
import MaintenancePage from './pages/MaintenancePage';
import { selectGlobalThemeMode } from './redux/slices/globalSettingsSlice';
import { useAppSelector } from './redux/store';
import { useCustomTheme } from './styles/styleHooks';

import useAuth from './utils/amplifyUtils';

const Login = lazy(() => import('./pages/Login'));
const Sandbox = lazy(() => import('./pages/Sandbox'));

const App = () => {
  const { gaUserId } = useAuth();
  const globalThemeMode = useAppSelector(selectGlobalThemeMode);
  const theme = useCustomTheme(globalThemeMode);
  const isMaintenanceMode = import.meta.env.VITE_APP_MAINTENANCE_MODE === 'true';

  useEffect(() => {
    ReactGA.initialize([
      {
        trackingId: 'G-MWHCMGX96T',
        gaOptions: {
          userId: gaUserId,
        },
        // gtagOptions: {},
      },
    ]);
  }, [gaUserId]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {isMaintenanceMode ? (
        <MaintenancePage />
      ) : (
        <Router>
          <RouterAnalytics />
          <Suspense fallback={<RouteLoadingFallback />}>
            <Routes>
              <Route path="/" element={<Navigate to="/play" replace />} />
              <Route path="login" element={<Login />} />
              <Route path="play" element={<Sandbox />}>
                <Route path=":templateId" element={<Sandbox />} />
              </Route>
            </Routes>
          </Suspense>
        </Router>
      )}
    </ThemeProvider>
  );
};

export default App;
